// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"styles_listContainer__BP8k1","singleTag":"styles_singleTag__6tUvo","activeTag":"styles_activeTag__XZSqk","error":"styles_error__WD_e5"};